import React from "react";
import {
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Label,
  ComposedChart,
  ResponsiveContainer,
} from "recharts";
import SalesProductCustomTooltip from "./salesProductCustomTooltip";

const ProductChart = ({ dataList }) => {
  const processedData = dataList.map((data) => {
    return {
      ...data,
      title: data.merchname || data.merchcategorytitle,
      cancellationRate: (data.refundcount / data.salescount).toFixed(2),
    };
  });

  return (
    <div
      style={{
        width: 893,
        height: processedData.length < 2 ? 125 : processedData.length * 96.55, // 965.5
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "51px 0px 30px 0px",
      }}
    >
      <ResponsiveContainer width="100%" height="100%">
        <ComposedChart
          data={processedData}
          layout="vertical" // X축과 Y축을 바꿔줌
          margin={{
            top: 10,
            right: 40,
            bottom: 20,
            left: 25,
          }}
        >
          <CartesianGrid
            stroke="rgba(255, 255, 255, 0.12)"
            horizontal={false} // 가로줄 제거
          />

          {/* 첫 번째 X축: % (상단) */}
          <XAxis
            type="number"
            axisLine={false} // X축 라인 제거
            stroke="rgba(255, 255, 255, 0.12)"
            xAxisId="top" // 상단 X축
            orientation="top" // 상단에 표시
            domain={[0, 1]} // 0% ~ 100%
            ticks={[0, 0.2, 0.4, 0.6, 0.8, 1]} // 0%, 20%, 40%, 60%, 80%, 100%
            tickFormatter={(value) => `${value * 100}`} // 퍼센트로 표시
            tick={{
              fontFamily: "Pretendard",
              fontWeight: 500,
              fontSize: 13,
              lineHeight: "18.75px",
              fill: "#aaa",
              textAnchor: "middle",
            }}
            tickMargin={12}
          >
            <Label
              value="(%)"
              position="insideLeft" // "insideBottomRight", "insideBottom", "insideBottomLeft", "insideTopRight", "insideTop", "insideTopLeft"
              dx={-40}
              dy={-9}
              style={{
                fontFamily: "Pretendard",
                fontWeight: 500,
                fontSize: 13,
                lineHeight: "18.75px",
                fill: "rgba(181, 181, 181, 0.5)",
              }}
            />
          </XAxis>

          {/* 두 번째 X축: 금액 (하단) */}
          <XAxis
            type="number"
            axisLine={false} // X축 라인 제거
            stroke="rgba(255, 255, 255, 0.12)"
            ticks={[0, 2000000, 4000000, 6000000, 8000000, 10000000]}
            tickFormatter={(value) => `${value.toLocaleString()}`}
            tickMargin={10}
            tick={{
              fontFamily: "Pretendard",
              fontWeight: 500,
              fontSize: 13,
              lineHeight: "18.75px",
              fill: "#aaa",
              textAnchor: "middle",
            }}
          >
            <Label
              value="(원)"
              position="insideLeft" // "insideBottomRight", "insideBottom", "insideBottomLeft", "insideTopRight", "insideTop", "insideTopLeft"
              dx={-15}
              dy={25}
              style={{
                fontFamily: "Pretendard",
                fontWeight: 500,
                fontSize: 13,
                lineHeight: "18.75px",
                fill: "rgba(181, 181, 181, 0.5)",
              }}
            />
          </XAxis>

          {/* Y축: 제품 이름 */}
          <YAxis
            dataKey="title"
            type="category"
            axisLine={false} // Y축 라인 제거
            stroke="rgba(255, 255, 255, 0.12)"
            tickSize={0} // Y축 눈금 제거
            tickMargin={173} // 숫자와 축 사이의 간격 조정 151 + 22
            width={151}
            tick={{
              fontFamily: "Pretendard",
              fontWeight: 400,
              fontSize: 14,
              lineHeight: "20.25px",
              fill: "#aaa",
              textAnchor: "start",
            }}
          />

          <Tooltip cursor={false} content={<SalesProductCustomTooltip />} />

          {/* 판매 금액과 취소 금액을 위한 Bar 차트 */}
          <Bar
            dataKey="realpay"
            barSize={18}
            fill="#38b5a6"
            radius={[0, 5, 5, 0]}
          />
          <Bar
            dataKey="refundamount"
            barSize={18}
            fill="#67c46b"
            radius={[0, 5, 5, 0]}
          />

          {/* 취소율을 위한 Line 차트, 상단 X축 사용 */}
          <Line dataKey="cancellationRate" stroke="#ffdf34" xAxisId="top" />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ProductChart;
